import FilterListIcon from '@mui/icons-material/FilterList'
import { IconButton, IconButtonProps } from '@mui/material'

const FilterIconButton = (props: IconButtonProps) => {
  return (
    <IconButton {...props}>
      <FilterListIcon sx={{ fontSize: 16 }} />
    </IconButton>
  )
}

export default FilterIconButton
